"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _PrimaryButton = _interopRequireDefault(require("../../button/PrimaryButton"));

var _StringOrRender = _interopRequireDefault(require("../../helper/StringOrRender"));

var _StaggeredFadeIn = _interopRequireDefault(require("../../effect/animation/StaggeredFadeIn"));

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _class, _class2, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var SimpleBannerItem = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(SimpleBannerItem, _Component);

  var _super = _createSuper(SimpleBannerItem);

  function SimpleBannerItem() {
    var _this;

    (0, _classCallCheck2["default"])(this, SimpleBannerItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    return _this;
  }

  (0, _createClass2["default"])(SimpleBannerItem, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          title = _this$props.title,
          body = _this$props.body,
          className = _this$props.className,
          style = _this$props.style;
      return /*#__PURE__*/_react["default"].createElement(_StaggeredFadeIn["default"], {
        className: (0, _styling.css)(this.styles.root, className, style),
        deltaY: 10,
        animationDurationMs: 500
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.content)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.contentText)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.title)
      }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
        value: title
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.body)
      }, /*#__PURE__*/_react["default"].createElement(_StringOrRender["default"], {
        value: body
      }))), this.renderPrimaryButton), this.renderBannerImg);
    }
  }, {
    key: "textColor",
    get: function get() {
      var textColor = this.props.textColor;
      var textBlack = this.context.theming.theme.textBlack;

      if (!textColor) {
        return textBlack;
      }

      return textColor;
    }
  }, {
    key: "styles",
    get: function get() {
      var fonts = this.context.theming.fonts;
      return _aphrodite.StyleSheet.create({
        root: {
          flex: 1,
          display: "flex",
          flexDirection: "row",
          padding: "20px 0px",
          alignItems: "center",
          justifyContent: "space-between"
        },
        content: {
          maxWidth: "60%",
          display: "flex",
          alignSelf: "stretch",
          alignItems: "flex-start",
          flexDirection: "column",
          justifyContent: "space-between",
          padding: "10px 15px 10px 0px"
        },
        contentText: {
          display: "flex",
          flexDirection: "column"
        },
        img: {
          maxWidth: "40%",
          alignSelf: "center"
        },
        title: {
          fontSize: 24,
          fontFamily: fonts.bold,
          lineHeight: 1.33,
          color: this.textColor,
          marginBottom: 15,
          cursor: "default",
          wordWrap: "break-word",
          whiteSpace: "normal"
        },
        body: {
          color: this.textColor,
          fontSize: 16,
          fontFamily: fonts.medium,
          lineHeight: 1.25,
          marginBottom: 25,
          cursor: "default",
          wordWrap: "break-word",
          whiteSpace: "normal"
        },
        cta: {
          alignSelf: "flex-start"
        }
      });
    }
  }, {
    key: "renderBannerImg",
    get: function get() {
      var bannerImg = this.props.bannerImg;

      if (bannerImg == null) {
        return null;
      }

      if (typeof bannerImg === "string") {
        return /*#__PURE__*/_react["default"].createElement("img", {
          className: (0, _styling.css)(this.styles.img),
          draggable: false,
          src: bannerImg,
          alt: "illustration"
        });
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.img)
      }, bannerImg());
    }
  }, {
    key: "renderPrimaryButton",
    get: function get() {
      var cta = this.props.cta;

      if (cta) {
        var text = cta.text,
            buttonProps = (0, _objectWithoutProperties2["default"])(cta, ["text"]);
        return /*#__PURE__*/_react["default"].createElement(_PrimaryButton["default"], (0, _extends2["default"])({
          className: (0, _styling.css)(this.styles.cta)
        }, buttonProps, {
          openInNewTab: true,
          style: _objectSpread(_objectSpread({}, buttonProps.style), {}, {
            fontSize: 18,
            border: "none",
            padding: "11px 60px"
          })
        }), text);
      }

      return null;
    }
  }]);
  return SimpleBannerItem;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.defaultProps = {
  logParams: {}
}, _class3.propDoc = {
  title: {
    required: true,
    type: "string | ((() => ReactNode))",
    description: "Title of the banner"
  },
  body: {
    required: true,
    type: "string | ((() => ReactNode))",
    description: "Body of banner. Appears below the title"
  },
  bannerImg: {
    required: true,
    type: "string | ((() => ReactNode))",
    description: "Illustration image of the banner"
  },
  cta: {
    required: true,
    type: "PrimaryButtonProps",
    description: "Props for the banner's CTA button."
  }
}, _temp), ((0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "textColor", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "textColor"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "renderBannerImg", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "renderBannerImg"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "renderPrimaryButton", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "renderPrimaryButton"), _class2.prototype)), _class2)) || _class;

var _default = SimpleBannerItem;
exports["default"] = _default;